import { render, staticRenderFns } from "./CrewDocument.vue?vue&type=template&id=49c20ee2&scoped=true&"
import script from "./CrewDocument.vue?vue&type=script&lang=js&"
export * from "./CrewDocument.vue?vue&type=script&lang=js&"
import style0 from "./CrewDocument.vue?vue&type=style&index=0&id=49c20ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c20ee2",
  null
  
)

export default component.exports